export default __webpack_public_path__ + "static/media/Background_Mobile_Login.e4084e5a.svg";